import { EmptyText } from './empty-text';

type Props = {
    children: string | undefined | null;
};

export const TextOrEmpty: React.FC<Props> = ({ children }) => {
    if (!children) {
        return <EmptyText />;
    }

    return <>{children}</>;
};
